import customFormTemplate from './tempalte.vue';

export default customFormTemplate;
